import FocusedCard from './FocusedCard';

export * from './FocusedCard';
export default FocusedCard;
